import { Alert, Checkbox, Loader, Modal, Stack } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Button } from '../../../../components/Button';
import { FaceCamera } from '../../../../components/FaceCamera/FaceCamera';
import { useAttendanceFaceEnrollment } from './useAttendanceFaceEnrollment';

export function AttendanceFaceEnrollmentModal({ employeeId, employeeName, onClose }: {
  employeeId: number; employeeName: string; onClose: () => void;
}) {
  const state = useAttendanceFaceEnrollment(employeeId, onClose);
  return <Modal opened onClose={state.close} title={`רישום פנים: ${employeeName}`} dir="rtl" centered size="md"
    closeOnClickOutside={!state.busy} closeOnEscape={!state.busy} closeButtonProps={{ disabled: state.busy }}>
    <Stack gap="sm">
      {state.loading && <Loader aria-label="טוען רישום פנים" />}
      {state.error && <Alert color="red">{state.error}</Alert>}
      {state.status?.enabled === false && <Alert color="orange">אימות פנים אינו מוגדר בסביבה הזאת</Alert>}
      {state.status?.enabled && <>
        <p>{state.status.enrolled ? 'קיימת תמונת פנים מאושרת' : 'טרם נרשמה תמונת פנים'}</p>
        <Checkbox label="אני מאשר שהעובד הסכים לשמירת תמונת פנים בישראל לצורך אימות נוכחות"
          checked={state.consent} disabled={state.busy} onChange={(event) => state.setConsent(event.currentTarget.checked)} />
        {state.consent && <FaceCamera onCapture={state.enroll} onCancel={() => state.setConsent(false)} disabled={state.busy} />}
        {state.status.enrolled && <Button variant="cancel" onClick={async () => { await state.revoke(); }} disabled={state.busy} ariaLabel="מחק תמונת פנים">
          <FontAwesomeIcon icon={faTrash as IconProp} /> מחק תמונת פנים
        </Button>}
      </>}
    </Stack>
  </Modal>;
}